module.exports = __webpack_public_path__ + "static/media/laundry-stacked-clothes.9a65b06e.jpg";